/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import {Card, CardBody, Col, Button, Form, FormGroup, Label, CardHeader, Row, Container} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../translations/global.json"
/** End of Multiple Language imports **/

import LanguageManager from '../custom-classes/language-manager';
import NavbarMobile from './navbar/navbar-mobile';
import NavbarDesktop from './navbar/navbar-desktop-top';
import FormGroupNewPassword from './forms/form-group-new-password';
import FormGroupName from './forms/form-group-name';
import ModalGeneric from './modals/modal-generic';
import SelectorSex from './selectors/selector-sex';
import DatePicker from './date-picker/date-picker';
import moment from 'moment';
import ApiCalls from '../custom-classes/api-calls';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import ProfilesDataTable from './datatables/profiles-data-table';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUser} from '@fortawesome/free-solid-svg-icons';
import Footer from './footer/footer';

/**
* The component (window) to update a profile information
*/
class ProfileUpdate extends React.Component {

    constructor(props) { // start with a constructor if we want to do modifications on events
        super(props); // Super is required.

        // Declare the properties and set the value according to what we are going to manage in the the page
        this.state = {
            studentId: null,
            firstName: '',
            lastName: '',
            password: '',
            passwordRetype: '',
            username: '',
            dob: null,
            sex: '',
            validPassword: false,
            usernameAvailable: true,
            validUsername: false,
            validFirstName: true,
            validLastName: true,
            propsModal: null,
            showErrorModal: false,
            createdAt: moment(),
            calendarFocused: false,
            proceedUpdateInformation: false,
            proceedUpdatePassword: false,
            navbarMobile: false,
            rendered: false,
            studentFullName: null
        };

        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });
        this.props.addTranslation(global);

        this.setUpdateInformationButtonState = this.setUpdateInformationButtonState.bind(this);
        this.setSubmitPasswordButtonState = this.setSubmitPasswordButtonState.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.updateStudentInformation = this.updateStudentInformation.bind(this);
        this.updatePassword = this.updatePassword.bind(this);
        this.showStudentBox = this.showStudentBox.bind(this);
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    /**
     * Renders the generic modal
     * @returns {XML}
     */
    renderGenericModal() {
        return (
            <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/>
        );
    }

    /**
     * Toggles alert modal (alert from registration)
     */
    toggleAlertModal() {
        this.setState({showErrorModal: false});
    }

    /**
     * Updates the profile password
     */
    updatePassword() {
        // Updates the student information
        let apiCall = ApiCalls.updateProfilePassword(this.state.password, this.state.passwordRetype, this.state.studentId.value);

        apiCall.then((returned)=> {
            let propsModal = {
                bodyText: returned.Messages[0],
                visible: true
            };
            this.setState({propsModal: propsModal, showErrorModal: true, loading: false});
        });
    }

    /**
     * Updates the user information
     */
    updateStudentInformation() {
        // Updates the student information
        let apiCall = ApiCalls.updateProfileInformation(this.state.firstName, this.state.lastName, this.state.sex,
            this.state.dob, this.state.studentId.value);

        apiCall.then((returned)=> {
            let propsModal = {
                bodyText: returned.Messages[0],
                visible: true
            };
            this.setState({propsModal: propsModal, showErrorModal: true, loading: false});
        });
    }

    /**
     * Sets the submit password button state
     */
    setSubmitPasswordButtonState() {
        this.setState({
            proceedUpdatePassword: (
                this.state.validPassword && this.state.studentId !== null
            )
        });
    }

    /**
     * Sets if submit button is ready or not
     */
    setUpdateInformationButtonState() {

        this.setState({
            proceedUpdateInformation: (
                this.state.firstName.length > 0 &&
                this.state.lastName.length > 0 &&
                this.state.validFirstName &&
                this.state.validLastName &&
                this.state.studentId !== null
            )
        });

    }

    /**
     * Sets the student ID and calls the user information
     * @param field
     */
    saveStudentIdState = (field) => (newValue)=> {
        console.log(newValue);
        this.setState({studentId: newValue, studentFullName: newValue.GivenName + ' ' + newValue.Surname}, ()=> {
            let apiCall = ApiCalls.getProfileInformation(newValue.value);
            apiCall.then((returned)=> {

                if (returned.TransactionValid) {
                    this.setState(
                        {
                            firstName: returned.ProfilesAccountModel.UserFullNameModel.GivenName,
                            lastName: returned.ProfilesAccountModel.UserFullNameModel.Surname,
                            dob: (returned.ProfilesAccountModel.UserDobModel !== null
                                ? returned.ProfilesAccountModel.UserDobModel.Dob : null),
                            sex: (returned.ProfilesAccountModel.UserGenderModel !== null
                                ? returned.ProfilesAccountModel.UserGenderModel.Gender : '')

                        }, ()=> {
                            this.setUpdateInformationButtonState();
                        }
                    );
                }
            });
        })
    };

    /**
     * Save the password state and verifies if the next button is ready
     * @param field
     */
    savePassword = (field) => (newValue) => {
        this.setState({
            'password': newValue.password, 'passwordRetype': newValue.passwordRetype,
            'validPassword': newValue.validPassword
        }, () => {
            this.setSubmitPasswordButtonState();
        });
    };

    /**
     * Save the name details and verifies if the next button is ready
     * @param field
     */
    saveName = (field) => (newValue) => {
        this.setState({
            'firstName': newValue.firstName, 'lastName': newValue.lastName,
            'validFirstName': newValue.validFirstName, 'validLastName': newValue.validLastName
        }, () => {
            this.setUpdateInformationButtonState();
        });
    };

    /**
     * Saves the sex
     * @param field
     */
    saveSex = (field) => (newValue) => {
        this.setState({'sex': newValue}, ()=> {
            this.setUpdateInformationButtonState();
        });
    };

    /**
     * Saves the DOB                        */
    saveDob = (field) => (newValue)=> {
        this.setState({'dob': newValue.date}, ()=> {
            this.setUpdateInformationButtonState();
        });
    };

    showStudentBox(){
        this.setState({
            studentId: null,
            productId: null
        });
    }

    /**
     * Renders the first part of the form
     * @returns {XML}
     */
    renderForm() {
        return (
            <div>
                <Container>
                    <Row>
                            <Col sm={{size: 12, offset: 0}} md={{size: 12}} lg={{size: 12}}>
                                <Card className="card-blue-transparency">
                                    <CardHeader>
                                        <h4 className="white-text">
                                            <Translate id="profile-update.edit-profile-select-student"
                                                       options={{renderInnerHtml: false}}/>
                                        </h4>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                        {
                                            this.state.studentId === null || this.state.studentId === '' ?
                                                <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                                    <ProfilesDataTable updateParent={this.saveStudentIdState()}/>
                                                </Col> : null
                                        }
                                        </Row>
                                        <Row>
                                            {
                                                typeof this.state.studentId !== 'undefined' && this.state.studentId !== null && this.state.studentId !== '' ?
                                                    <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                                        <Translate id="report-student-average.selected-student"
                                                                   options={{renderInnerHtml: false}}/>
                                                        : <span className="yellow-text"><b> {this.state.studentFullName} </b></span> {' '}

                                                        <Button color="warning" onClick={this.showStudentBox}>
                                                            <Translate id="report-student-average.select-a-student"
                                                                       options={{renderInnerHtml: false}}/>
                                                        </Button>
                                                    </Col> : null
                                            }
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                    </Row>
                </Container>

                <Container>
                    <Row>
                        <Col sm={{size: 12, offset: 0}} md={{size: 6}} lg={{size: 6}}>
                            <Card className="card-blue-transparency">
                                <CardHeader>
                                    <h4 className="white-text">
                                        <Translate id="profile-update.edit-profile" options={{renderInnerHtml: false}}/>
                                    </h4>
                                    <small>
                                        <Translate id="profile-update.edit-profile-subtitle"
                                                   options={{renderInnerHtml: true}}/>
                                    </small>
                                </CardHeader>
                                <CardBody>
                                    <Form>
                                        <FormGroupName data={this.state} updateParent={this.saveName()}/>
                                        <FormGroup row>
                                            <Col sm={{size: 12}}>
                                                <Label for="sex">
                                                    <Translate id="profile-register.sex"/>
                                                </Label>
                                                <SelectorSex value={this.state.sex} data={this.state}
                                                             updateParent={this.saveSex()}/>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup row>
                                            <Col sm={{size: 12}}>
                                                <Label for="dob">
                                                    <Translate id="profile-register.dob"/>
                                                </Label>
                                                <DatePicker data={this.state} updateParent={this.saveDob()}/>
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Col sm={{size: 12}}>
                                                <Button color="success" block
                                                        disabled={!this.state.proceedUpdateInformation}
                                                        onClick={this.updateStudentInformation}>
                                                    <Translate id="profile-update.update-information"
                                                               options={{renderInnerHtml: false}}/>
                                                </Button>
                                            </Col>
                                        </FormGroup>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col sm={{size: 12, offset: 0}} md={{size: 6}} lg={{size: 6}}>
                            <Container>
                                <Row>
                                    <Card className="card-blue-transparency">
                                        <CardHeader>
                                            <h4 className="white-text">
                                                <Translate id="profile-update.reset-profile-password"
                                                           options={{renderInnerHtml: false}}/>
                                            </h4>
                                            <small>
                                                <Translate id="profile-update.reset-profile-password-subtitle"
                                                           options={{renderInnerHtml: true}}/>
                                            </small>
                                        </CardHeader>
                                        <CardBody>
                                            <Form>
                                                <FormGroupNewPassword data={this.state}
                                                                      updateParent={this.savePassword()}/>
                                                <Button color="success" block
                                                        disabled={!this.state.proceedUpdatePassword}
                                                        onClick={this.updatePassword}>
                                                    <Translate id="profile-update.save-password"
                                                               options={{renderInnerHtml: false}}/>
                                                </Button>
                                            </Form>
                                        </CardBody>
                                    </Card>
                                </Row>
                            </Container>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    };

    /**
     * Renders the main form element
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding">
                    <Container className="margin-top-mandatory-60">
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faUser}/>{' '}
                            <Translate id="dashboard.profiles-edit" options={{renderInnerHtml: true}}/>
                        </h2>
                        <hr/>
                        {this.renderForm()}
                        {this.state.showErrorModal ? this.renderGenericModal() : null}
                    </Container>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default withLocalize(ProfileUpdate);